import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Card, FormControl, Grid } from '@mui/material';
import { WsTypoVariants, WsTypography } from 'wisestep-base';

import PopoverOnClick from '../../clientListingPage/components/PopoverOnClick';

interface IHeaderProps {
  title: string;
  options: string[];
  onSelect: (value: string) => void;
}

const CommonHeader = ({ title, options, onSelect }: IHeaderProps) => {
  return (
    <Card sx={{ minHeight: 20 }}>
      <Grid container>
        <Grid item xs={6}>
          <FormControl>
            <PopoverOnClick
              element={
                <Grid container p={1} alignItems="center">
                  <WsTypography variant={WsTypoVariants.TITLE} cursor="pointer">
                    {title}
                  </WsTypography>
                  <KeyboardArrowDownIcon />
                </Grid>
              }
            >
              {options.map((option) => (
                <Grid p={1} key={option}>
                  <WsTypography
                    variant={WsTypoVariants.SUB_TITLE}
                    cursor="pointer"
                    onClick={() => onSelect(option.toLowerCase().replace(' ', '_'))}
                  >
                    {option}
                  </WsTypography>
                </Grid>
              ))}
            </PopoverOnClick>
          </FormControl>
        </Grid>
      </Grid>
    </Card>
  );
};

export default CommonHeader;
